<!-- 
Expander panel showing the risk rated premium calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelRiskRatedPremiumBreakdown)"
    >
      Calculation breakdown: Risk rated premium component
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.RiskRatedPremiumComponent"/>
        <v-card-text class="pa-0">
          <our-data-container v-if="!riskPremiumAmountsOverridden" right fluid>
            <our-data-field label-width="3">
              <template slot="label">
                (Number of students * Risk premium per student) + ({{ totalLoanTypeDescription }} * Risk premium percentage)
              </template>
              ({{ levyParameters.studentCount | number }} * {{ levyCollection.riskPremiumPerStudent | currency }})
              + 
              ({{ levyParameters.loanAmountsPaid | currency }} * {{ levyCollection.riskPremiumRate | percentage }})
              =
              {{ levyCalculation.riskPremiumBase | currency }}
            </our-data-field>
            <our-data-field label-width="3">
              <template slot="label">
                <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelFinancialStrengthScore)">
                  Financial strength risk factor value
                </a>
                + 
                <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelCourseCompletionScore)">
                  Completion rate risk factor value
                </a>
                + 
                <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelNonComplianceScore)">
                  Non-compliance history risk factor value
                </a>
              </template>
              {{ levyCalculation.financialStrengthScore | numericInput2 }} + 
              {{ levyCalculation.courseCompletionScore | numericInput2 }} + 
              {{ levyCalculation.nonComplianceScore | numericInput2 }}
              =
              {{ totalRiskScore | numericInput2 }}
            </our-data-field>
            <our-data-field label-width="3" label="Total risk rated premium">
              {{ levyCalculation.riskPremiumBase | currency }} + ({{ levyCalculation.riskPremiumBase | currency }} * {{ totalRiskScore | numericInput2 }})
              =
              <span class="title">
                {{ levyCalculation.riskRatedPremiumComponent | currency }}
              </span>
              <template v-slot:footer>
                <playground-up-down v-if="isLevyEstimator" field="riskRatedPremiumComponent" small/>
              </template>
            </our-data-field>
          </our-data-container>
          <our-data-container v-else right fluid>
            <our-data-field :label="calculationOverride.riskRatedPremiumComponentDescription" typography="title">
              {{ levyCalculation.riskRatedPremiumComponent | currency }}
            </our-data-field>
          </our-data-container>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";

export default {
  components: {
    PlaygroundUpDown
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
